import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const downloadInsightsForDate = async (
  jobId: number,
  date: string
): Promise<Blob> => {
  return apiClient
    .get(`${ENDPOINTS.DOWNLOAD_INSIGHTS_FOR_DATE(jobId.toString(), date)}`)
    .blob();
};

export const useDownloadInsightsForDateQuery = (
  jobId: number | null,
  date: string,
  options?: Omit<UseQueryOptions<Blob, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["downloadInsightsForDate", jobId, date],
    queryFn: () => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return downloadInsightsForDate(jobId, date);
    },
    enabled: false, // This ensures the query doesn't run automatically
    ...options,
  });
};
